import { usePatientData } from "./usePatientData";
import { useAppointmentData } from "./useAppointmentData";
import { useAppointmentParamsFromQuery } from "./useAppointmentParamsFromQuery";

// uses the patientsMappedToIds object returned by usePatientData to find the patient
// that owns the appointment for which the user is currently viewing, or null.

export const useActivePatient = () => {
  const {
    appointmentId,
    appointmentDateISOString,
  } = useAppointmentParamsFromQuery();

  const { appointment } = useAppointmentData({
    selectedDateISOString: appointmentDateISOString,
    appointmentId,
    preventRefetch: true,
  });

  // Prefer fetching the single patient by ID; fall back to the mapped list
  const { patientsMappedToIds, singlePatient } = usePatientData({
    preventRefetch: true,
    patientId: appointment?.patient_id,
  });

  const activePatient = singlePatient || (appointment && patientsMappedToIds[appointment.patient_id]);

  return { activePatient };
};
